"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SwitcherButton = function SwitcherButton(_ref) {
  var children = _ref.children,
      active = _ref.active,
      onClick = _ref.onClick,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "active", "onClick", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledSwitcherButton, _extends({
    active: active,
    onClick: onClick,
    className: className
  }, otherProps), children);
};

var StyledSwitcherButton = _styledComponents.default.div.withConfig({
  displayName: "StyledSwitcherButton"
})(["padding:1.8rem 2.4rem;font-family:", ";font-weight:", ";font-size:1.4rem;line-height:1.4rem;color:", ";cursor:pointer;transition:color 0.15s ease-in-out;&:hover{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var active = _ref3.active;
  return active ? '500' : '400';
}, function (_ref4) {
  var theme = _ref4.theme,
      active = _ref4.active;
  return active ? theme.brand.primary : '#d5d5d5';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

SwitcherButton.propTypes = {
  /** Content to be displayed inside the button. */
  children: _propTypes.node.isRequired,

  /** Pass this bool to set the button to active. */
  active: _propTypes.bool,

  /** Function to be ran when the button is clicked. */
  onClick: _propTypes.func.isRequired,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = SwitcherButton;
exports.default = _default;